import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChargeService } from 'app/core/services/charge.service';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { EmployeeRelation } from 'app/shared/models/employee-relation';
import { PayrollDepartment } from 'app/shared/models/payroll-department';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'dialog-process-importtimesheet',
  templateUrl: './dialog-process-importtimesheet.component.html',
  styleUrls: ['./dialog-process-importtimesheet.component.scss']
})
export class DialogProcessImporttimesheetComponent implements OnInit {

  payrolls: any[] = [];
  period: any[] = [];
  processForm: FormGroup;
  schedules: any[] = [];

  payrollCtrl = new FormControl('');
  periodCtrl = new FormControl('');
  scheduleCtrl = new FormControl('');

  filteredPayrolls!: Observable<any[]>;
  filteredPeriods!: Observable<any[]>;
  filteredSchedules!: Observable<any[]>;

  constructor(public dialogRef: MatDialogRef<DialogProcessImporttimesheetComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private fb: FormBuilder, private processSchedulerService: ProcessSchedulerService) {
    this.processForm = this.fb.group({
      payroll: ['', Validators.required],
      period: ['', Validators.required],
      schedule: ['', Validators.required],
      // startDate: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getPayrolls();
    this.getSchedules();
    this.periodCtrl.disable();

    this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.payrolls, 'payrollType'))
    );

    this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.period, 'payrollName'))
    );

    this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.schedules, 'name'))
    );

    this.payrollCtrl.valueChanges.subscribe(value => {
      if (!value) {
        this.periodCtrl.disable();
        this.periodCtrl.setValue('');
      } else {
        this.periodCtrl.enable();
      }
    });
  }

  private _filter(value: string, list: any[], key: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return list?.filter(item => item[key]?.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getSchedules() {
    this.processSchedulerService.getSchedules().subscribe({
      next: res => {
        this.schedules = res;
        this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.schedules, 'name'))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrolls() {
    this.privateService.getPayrollType().subscribe(res => {
      this.payrolls = res;
      this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.payrolls, 'payrollType'))
      );
    });
  }

  onPayrollSelected(payrollType: string) {
    const selected: any = this.payrolls.find(d => d.payrollType === payrollType);
    if (selected) {
      this.processForm.get('payroll')?.setValue(selected.hrpayrollID);
    }
    this.privateService.getPeriodOnDepartment(selected.hrpayrollID).subscribe(response => {
      console.log(response);
      this.period = response;
      this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.period, 'payrollName'))
      );
    })
  }

  onPeriodSelected(payrollName: string) {
    const selected = this.period.find(e => e.payrollName === payrollName);
    if (selected) {
      this.processForm.get('period')?.setValue(selected.hrperiodID);
    }
  }

  onScheduleSelected(name: string) {
    const selected = this.schedules.find(c => c.name === name);
    if (selected) {
      this.processForm.get('schedule')?.setValue(selected.id);
    }
  }

  onSubmit(): void {
    if (this.processForm.valid) {
      const formData = this.processForm.value;
      this.processSchedulerService.insert_time_entries_process(formData).subscribe((res) => {
        this.dialogRef.close();
        window.location.reload();
      })
    } else {
      console.log('Form is invalid');
    }
  }
}